import ParameterGroupsList from "./ParameterGroupsList";

const ParameterGroupsSetupPage = () => <ParameterGroupsList />;

export default ParameterGroupsSetupPage;
